<prox-main [parent]="this" [bodyTemplate]="bodyTemplate" [footerTemplate]="footerTemplate"></prox-main>
<ng-template #bodyTemplate>
  <prox-activation-checklist *ngIf="isValidateActivated"
    [activationErrors]="activationService.activateErrors"
    [entityName]="account!.name"
    [activationService]="activationService"></prox-activation-checklist>

  <!-- The grid below is full width, so ml-auto right-aligns Analyze with the grid edge. -->
  <div class="qb-list-actions">
    <p-button (onClick)="onSugAdd()" label="Add Shipping User Group" icon="pi pi-plus" size="small"
      [disabled]="isReadOnly()" id="sugAddBtn"></p-button>
    <span class="qb-status-message">{{statusMessage()}}</span>
    <div class="ml-auto flex items-center">
      <p-button (onClick)="analyzeMenu.toggle($event)" size="small" label="Analyze" icon="pi pi-chart-bar"
        iconPos="left" severity="secondary" [outlined]="true" id="sugAnalyzeBtn"></p-button>
      <p-menu #analyzeMenu [model]="analyzeItems" [popup]="true" appendTo="body"></p-menu>
    </div>
  </div>

  <p-splitter class="w-full grow qb-splitter-after-actions" layout="vertical" styleClass="h-full" [panelSizes]="[40, 60]">
    <ng-template pTemplate>
      <div class="qb-splitter-panel">
        <div class="qb-splitter-grid">
          <prox-ag-grid gridId="shippingUserGroupsGrid" [gridOptions]="sugGridOptions"></prox-ag-grid>
        </div>
      </div>
    </ng-template>
    <ng-template pTemplate>
      <div class="qb-splitter-panel">
        <div class="qb-child-actions">
          <p-button [disabled]="!selectedSug || this.isReadOnly()" (onClick)="onUserAttach()"
            label="Add Users to Shipping User Group" icon="pi pi-plus" size="small" id="sugmAddBtn"></p-button>
        </div>
        <div class="qb-splitter-grid">
          <prox-ag-grid gridId="shippingUsersGrid" [gridOptions]="userGridOptions" [rowData]="users"></prox-ag-grid>
        </div>
      </div>
    </ng-template>
  </p-splitter>
</ng-template>
<ng-template #footerTemplate>
  <prox-save-cancel [uow]="this" (undo)="onUndo()" (save)="onSave()" (cancel)="onCancel()"></prox-save-cancel>
</ng-template>